module.exports = __webpack_public_path__ + "img/artice-b.f7e1bf38.jpg";